// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1Vdtq","list":"BalanceDue_list__1KG9D","listRow":"BalanceDue_listRow__1l1SD","total":"BalanceDue_total__Rnr19"};